import type { ForwardRefExoticComponent, HTMLAttributes, RefAttributes } from "react";

export const ICONSAX_SIZE = {
    SMALL: 16,
    LARGE: 24,
} as const;

export type IconsaxSize = (typeof ICONSAX_SIZE)[keyof typeof ICONSAX_SIZE];

export interface IconsaxProps extends Omit<HTMLAttributes<HTMLDivElement>, "size" | "color"> {
    size?: IconsaxSize;
    color?: string;
}

export type IconsaxComponent = ForwardRefExoticComponent<IconsaxProps & RefAttributes<HTMLDivElement>>;

export const ICONS_COLORS = {
    primary: "primary",
    secondary: "secondary",
    tertiary: "tertiary",
    blue: "blue",
    success: "success",
    error: "error",
    warning: "warning",
    information: "information",
    default: "default",
    title_active: "title_active",
    placeholder: "placeholder",
    pink: "pink",
    turquoise: "turquoise",
    coral: "coral",
    orange: "orange",
    yellow: "yellow",
    salmon: "salmon",
    black: "black",
    linear_gradient: "linear_gradient",
} as const;

export const iconColors = Object.values(ICONS_COLORS);

/**
 * Type for predefined icon colors.
 */
export type IconColor = (typeof iconColors)[number];
